import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';
import { SearchCondition } from 'src/app/shared/model/search-condition.model';
import { StringService } from 'src/app/shared/service/string.service';

@Component({
  selector: 'app-item-required-skills',
  templateUrl: './required-skills.component.html',
  styleUrls: ['./required-skills.component.scss']
})
export class RequiredSkillsComponent implements OnInit {
  @Input() searchParams: SearchCondition;
  @Input() allSkills: string[][] = [];
  @Input() open: boolean;

  @Output() newSearch = new EventEmitter<any>();

  last_val = '';
  skillCandidate = new Subject<string>();
  skillCandidate$ = this.skillCandidate.pipe(
    map(val => {
      const current_input = val.split(new RegExp('[\x20\u3000]|<|>')).slice(-1)[0];
      const prev_val = current_input.length > 0 ? val.slice(0, -current_input.length) : val;

      const filtered_skills = this.allSkills.filter(skill => ~skill[0].indexOf(current_input.toUpperCase()));
      let skill_meanings = filtered_skills.map(skill => skill[1]);
      skill_meanings = Array.from(new Set(skill_meanings)); // 重複削除

      // サジェスト一覧を作成
      let candidates = skill_meanings.map(meaning => [prev_val, meaning]);
      candidates = candidates.length > 50 ? candidates.slice(0, 50) : candidates;

      return candidates;
    })
  );
  constructor(private stringService: StringService) {}

  ngOnInit() {
    this.last_val = this.searchParams.required_skills;
  }

  resetSearchSkillList() {
    this.searchParams.required_skills = '';
    this.newRequest();
  }

  newRequest() {
    this.last_val = this.searchParams.required_skills;
    this.newSearch.next();
  }

  onBlur() {
    if (this.last_val !== this.searchParams.required_skills) {
      this.newRequest();
    }
  }

  EnterOnSearchBox(event): void {
    if (event.key === 'Enter' && !event.isComposing) {
      event.preventDefault();
      this.newRequest();
    }
  }
}
